import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { map, switchMap, catchError, } from 'rxjs/operators';

import {
    DUPLICATE_FROM_SELECTED_APP,
    DUPLICATE_FROM_SELECTED_APP_SUCCESS ,
    DUPLICATE_FROM_SELECTED_APP_FAIL,
} from '../../constants';


const cloneOrganisations = (action$, state$) =>
  action$.pipe(
    ofType(DUPLICATE_FROM_SELECTED_APP),
    switchMap(action =>
      ajax({
        url: `${state$.value.auth.poiServer}/cloneOranisationsToApp`,
        headers: {
          Authorization: `Bearer ${state$.value.auth.token}`,
          'Content-Type': 'application/json',
        },
        responseType: 'json',
        crossDomain: true,
        body: action.data,
        method: 'POST',
      }).pipe(
        map(response => {
            console.log(response)
          return {
            type: DUPLICATE_FROM_SELECTED_APP_SUCCESS,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: DUPLICATE_FROM_SELECTED_APP_FAIL,
            error,
          })
        )
      )
        
    )
  );

export default cloneOrganisations;
